<template>
    <div>
        <nav v-if="this.show_navbar" class="navbar navbar-expand navbar-default fixed-top">
            <div class="container">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <router-link v-tooltip:bottom="'Home page'" class="nav-link" :to="{name: 'home'}">
                            <i class="fa fa-home"></i>
                        </router-link>
                    </li>
                    <!-- + locali -->
                    <inc-dropdown-rooms v-if="this.isMultiChoice"/>
                </ul>

                <ul class="navbar-nav navbar-right">
                    <li class="nav-item" v-if="!this.userAuthenticated">
                        <router-link :to="{name:'user.login'}"
                                     v-tooltip:bottom="'Login'" class="nav-link">
                            <i class="fas fa-lock"></i>
                        </router-link>
                    </li>

                    <li class="nav-item d-none d-md-block" v-if="!this.userAuthenticated">
                        <router-link :to="{name:'user.registration'}"
                                     v-tooltip:bottom="$t('account.registrazione')" class="nav-link">
                            <i class="fas fa-pencil-alt"></i>
                        </router-link>
                    </li>

                    <li class="nav-item d-none d-md-block" v-if="this.userAuthenticated">
                        <a href="#" v-tooltip:bottom="'Logout'" class="nav-link"
                           @click.prevent="handleLogout()">
                            <i class="fa fa-unlock-alt"></i>
                        </a>
                    </li>

                    <!-- compare solo le sono loggato -->
                    <li class="nav-item" v-if="this.userAuthenticated">
                        <router-link :to="{name:'user'}"
                                     v-tooltip:bottom="$t('layout_profilo_tooltip')"
                                     class="nav-link">
                            <i class="fa fa-user"></i>
                        </router-link>
                    </li>

                    <li class="nav-item d-none d-md-block" v-if="this.enableReservations">
                        <router-link :to="{name:'reservations.reserve'}"
                                     v-tooltip:bottom="$t('layout_prenota_tooltip')"
                                     class="nav-link"
                                     v-if="!this.locale.prenota_tavolo_external_url">
                            <img src="/img/be/ico-tavolo.png">
                            <span class="d-none badge badge-info">
                                    &nbsp;&nbsp;{{ $t('prenotazione_tavolo.submit_btn') }}
                                </span>
                        </router-link>

                        <a target="_blank"
                           v-tooltip:bottom="$t('layout_prenota_tooltip')"
                           :href="`${this.locale.prenota_tavolo_external_url}`"
                           class="nav-link"
                           v-if="this.locale.prenota_tavolo_external_url">
                            <img src="/img/be/ico-tavolo.png">
                            <span class="d-none badge badge-info">
                                    &nbsp;&nbsp;{{ $t('prenotazione_tavolo.submit_btn') }}
                                </span>
                        </a>
                    </li>

                    <li class="nav-item" v-if="this.userAuthenticated && this.enableMessaging">
                        <router-link :to="{name:'messaging'}" v-tooltip:bottom="$t('messaggistica')"
                                     class="nav-link">
                            <i class="fa fa-comments"></i>&nbsp;&nbsp;
                            <span class="badge badge-info" v-if="this.unread_messages_counter">
                                    {{ this.unread_messages_counter }}
                                </span>
                        </router-link>
                    </li>

                    <li class="nav-item" v-if="this.enableFidelityCard">
                        <router-link :to="{name:'fidelity'}" v-tooltip:bottom="$t('layout_fidelity_card')"
                                     class="nav-link">
                            <i class="fa fa-address-card"></i>
                        </router-link>
                    </li>

                    <li class="nav-item" v-if="this.enableCoupons">
                        <router-link :to="{name: 'orders.discounts'}"
                                     v-tooltip:bottom="$t('layout_opzioni_label_csconto_tooltip')"
                                     class="nav-link">
                            <i class="fa fa-bell"></i>&nbsp;&nbsp;
                            <span class="badge badge-info">{{ this.counter_discount_codes }}</span>
                        </router-link>
                    </li>

                    <li class="nav-item">
                        <router-link :to="{name:'cart'}"
                                     v-tooltip:bottom="$t('layout_carrello_tooltip')" class="nav-link">
                            <i class="fa fa-shopping-cart"></i>&nbsp;<span
                            class="d-none d-lg-inline-block mx-2">{{ $t('layout_carrello_tooltip') }}</span>
                            <span class="badge badge-info" v-if="this.order.total_items">
                                    {{ this.order.total_items }}
                                </span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </nav>
        <div v-if="this.show_navbar" class="fixed-top optionbar mx-0">
            <div class="container d-flex justify-content-between px-0">
                <router-link :to="{name:'orders'}" class="a1">
                    <i class="fas fa-sliders-h mr-4"></i>
                    <span v-if="this.order_started">
                            <transition-group name="fade" mode="out-in">
                                <span :key="0" v-if="this.order.blinker_keys[this.order.blinker_idx] === 0">
                                    <span v-if="this.order.label_tipologia">
                                        {{ this.order.label_tipologia }}
                                    </span>
                                    <span v-else-if="this.order.type === 'TAKEAWAY'">
                                        {{ $t('takeaway') }}
                                    </span>
                                    <span v-else-if="this.order.type === 'DELIVERY'">
                                        {{ $t('delivery') }}
                                    </span>
                                    <span v-else-if="this.order.type === 'MANGIA_RISTORANTE'">
                                        {{ $t('eat_at_restaurant') }}
                                    </span>
                                    <span v-else-if="this.order.type === 'ORDINA_TAVOLO'">
                                        {{ $t('al_tavolo') }}
                                    </span>
                                    <span v-else>
                                        {{ this.order.type }}
                                    </span>
                                </span>
                                <span :key="1" v-if="this.order.blinker_keys[this.order.blinker_idx] === 1">
                                    {{ this.orderOptionsDescription(this.language) }}
                                </span>
                                <span :key="2" v-if="this.order.blinker_keys[this.order.blinker_idx] === 2">
                                    (<img class="m-0 p-0 px-1" height="20"
                                          src="/img/be/ico-asap.png"/> {{ $t('ordine_appena_possibile') }})
                                </span>
                                <span :key="3" v-if="this.order.blinker_keys[this.order.blinker_idx] === 3">
                                    {{ this.order.address.formatted_address }}
                                </span>
                            </transition-group>
                        </span>
                    <span v-else>
                            {{ this.specificTranslation("quando_vuoi_mangiare") }}
                        </span>
                </router-link>
                <router-link :to="{name:'menu.categories'}" class="a1" v-if="this.order_started">
                    <i class="fa fa-book"></i>&nbsp;&nbsp;&nbsp;&nbsp;
                    <b class="text-uppercase">{{ $t('ordine_menu_btn') }}</b>
                </router-link>
            </div>
            <transition name="fade">
                <mcw-linear-progress indeterminate v-if="this.loading_visible"></mcw-linear-progress>
            </transition>
        </div>

        <section class="container-fluid">
            <inc-restaurant-logo :targa="this.targaRistorante"/>

            <splash-screen v-if="this.splashscreen_visible" :targa="this.targaRistorante"/>
            <maintenance v-else-if="this.maintenance" :text="this.maintenanceText" :targa="this.targaRistorante"/>
            <div v-else>
                <transition name="fade">
                    <!--<keep-alive>-->
                    <router-view></router-view>
                    <!--</keep-alive>-->
                </transition>
            </div>
        </section>

        <inc-footer-languages v-if="!this.splashscreen_visible" :lingue-attive="this.lingue_attive"/>
        <inc-copyright/>

        <modal-reset-cart-confirm v-if="this.show_modal_cart_reset"/>

        <modal-cart-expired v-if="this.show_modal_cart_expired"/>
        <modal-cart-timer v-if="this.show_modal_cart_timer"/>

        <modal-errors v-if="this.show_modal_errors"/>
    </div>
</template>
<script>
import {mapState, mapActions, mapGetters} from 'vuex';

import {getCoupons, sendFirebaseToken, status} from '../api/account';
import {getRestaurantInfo, getStatus} from '../api/restaurant';

import firebase from "../firebase/firebase-service";

import IncCopyright from './partials/IncCopyright';
import IncFooterLanguages from './partials/IncFooterLanguages';
import IncRestaurantLogo from './partials/IncRestaurantLogo';
import SplashScreen from './SplashScreen';
import Maintenance from './Maintenance';
import ModalErrors from "./partials/ModalErrors";
import ModalConfirm from './partials/ModalConfirm';
import ModalCartExpired from './cart/partials/ModalCartExpired';
import ModalCartTimer from './cart/partials/ModalCartTimer';
import ModalResetCartConfirm from './partials/ModalResetCartConfirm';
import IncDropdownRooms from "./partials/IncDropdownRooms";


export default {
    props: ['idRistorante', 'targaRistorante', 'fwpcRistorante'],
    components: {
        IncDropdownRooms,
        ModalErrors,
        ModalResetCartConfirm,
        ModalCartTimer,
        ModalCartExpired,
        IncCopyright,
        IncFooterLanguages,
        IncRestaurantLogo,
        SplashScreen,
        Maintenance,
        ModalConfirm
    },
    data() {
        return {
            id_ristorante: this.idRistorante,
            lingue_attive: [],
            counter_discount_codes: null,
            maintenance: false,
            maintenanceText: null,
            show_navbar: false,

            can_receive_notifications: false
        }
    },
    created() {
        //per prima cosa setto la lingua
        this.$root.$i18n.locale = this.language;

        //fetcho
        this.showSplashscreen(true);
        this.fetchInfo();

        if (this.userAuthenticated) {
            //setup firebase
            this.setupFirebase();
        }
    },
    computed: {
        ...mapGetters('restaurant', [
            'enableReservations',
            'enableFidelityCard',
            'enableMessaging',
            'enableCoupons',
            'isMultiChoice',
            'restaurantServices',
            'specificTranslation'
        ]),
        ...mapGetters('auth', {
            userAuthenticated: 'authenticated'
        }),
        ...mapGetters('chat', {
            unread_messages_counter: 'counter'
        }),
        ...mapGetters('order', {
            order_started: 'started',
            orderOptionsDescription: 'optionsDescription'
        }),
        ...mapState('localization', {
            language: state => state.language,
            initialized: state => state.initialized,
        }),
        ...mapState('global', {
            splashscreen_visible: state => state.splashscreen_visible,
            loading_visible: state => state.loading_visible,
            show_modal_cart_expired: state => state.show_modal_cart_expired,
            show_modal_cart_timer: state => state.show_modal_cart_timer,
            show_modal_cart_reset: state => state.show_modal_cart_reset,
            show_modal_errors: state => state.show_modal_errors
        }),
        ...mapState('restaurant', {
            restaurant: state => state,
            locale: state => state.locale
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('chat', {
            unread_messages: state => state.unread_messages
        })
    },
    watch: {
        language: function () {
            this.fetchInfo();
        },
        userAuthenticated: function (authenticated) {
            if (authenticated) {
                this.setupFirebase();
                this.retrieveMessages();
            } else {
                //remove firebase instance
                firebase.destroy();
                this.can_receive_notifications = false;
            }
        },
        locale: function (newLocale, oldLocale) {
            if (!oldLocale || (newLocale.id !== oldLocale.id)) {
                this.fetchMoreInfo();
            }
        },
        $route(to, from) {
            // react to route changes...
            this.show_navbar = !this.splashscreen_visible && !this.maintenance && to.meta.showNav;
        }
    },
    methods: {
        fetchInfo: function () {
            getRestaurantInfo(this.language, {
                id_ristorante: this.id_ristorante
            }).then(response => {
                this.initialize({
                    id: this.idRistorante,
                    targa: this.targaRistorante,
                    servizi_attivi: response.servizi_attivi,
                    locali: response.locali,
                    impostazioni: response.impostazioni,
                    monete: response.monete,
                    punti_di_servizio: response.punti_di_servizio,
                    franchising: response.franchising,
                    f_stripe: response.f_stripe,
                    f_modalita_fiera: response.f_modalita_fiera,
                    f_distretto: response.f_distretto,
                    specific_translations: response.specific_translations,
                    f_deliverect: response.f_deliverect
                });

                if (this.$route.name === "user.password.reset") {
                    if (this.$route.query.idLocale) {
                        this.setLocale(this.restaurant.locali.find((room) => {
                            return room.id == this.$route.query.idLocale;
                        }));
                    }
                }

                this.lingue_attive = response.lingue_attive;

                const newLanguageCode = this.checkLanguage();
                if (newLanguageCode) {
                    this.setLanguage(newLanguageCode);
                } else {
                    this.fetchMoreInfo();
                    setInterval(() => {
                        this.fetchMoreInfo();
                    }, 100000);
                }

                if (response.facebook_pixel_id) {
                    this.$analytics.fbq.init(response.facebook_pixel_id, {
                        router: this.$router
                    });
                    this.$analytics.fbq.event('PageView');
                }
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            });
        },
        fetchMoreInfo: function () {

            const promises = [this.retrieveMaintenanceStatus()];

            if (this.locale && this.enableCoupons) {
                promises.push(this.retrieveCouponCounter());
            }

            if (this.userAuthenticated) {
                promises.push(this.retrieveMessages());
            }

            axios.all(promises).then(() => {
                if (this.splashscreen_visible) {
                    if (!this.locale) {
                        this.goToMain();
                    }

                    this.showSplashscreen(false);
                    this.show_navbar = !this.maintenance && this.$route.meta.showNav;
                    this.startBlinker();

                    //start timer ordine
                    if (this.order.time_limit) {
                        this.startOrderAlertTime({
                            end_date: this.order.time_limit
                        });
                    }
                }
            }).catch(error => {
                // react on errors.
                console.log('Generic ERROR:', error);
            });
        },
        retrieveMaintenanceStatus: async function () {
            let response = null;

            try {
                response = await getStatus(this.language, {
                    id_ristorante: this.id_ristorante,
                });
            } catch ({messages}) {
                alert(messages.join('\n'));
                throw "maintenance request failed";
            }

            if (response) {
                const nuoviLocali = [];
                let shouldUpdateLocali = false;
                response.infoLicenze.forEach((infoLicenza) => {
                    const vecchioLocale = this.restaurant.locali.find(vecchioLocale => vecchioLocale.id === infoLicenza.id_locale);

                    if (vecchioLocale) {
                        if (infoLicenza.f_locale_morto) {
                            shouldUpdateLocali = true;
                        } else {
                            vecchioLocale.licenza = infoLicenza;
                            nuoviLocali.push(vecchioLocale);
                            shouldUpdateLocali = true;
                        }
                    }
                });

                if (shouldUpdateLocali) {
                    //Qui entra solo se i locali sono diversi dal primo fetch, quindi non trigghera il watch sul locale la prima volta
                    this.setLocali(nuoviLocali);
                    if (this.locale) {
                        const localeAttuale = nuoviLocali.find(nuovoLocale => nuovoLocale.licenza.f_attivo && nuovoLocale.id === this.locale.id);
                        if (localeAttuale) {
                            this.setLocale(localeAttuale);
                        } else {
                            this.goToMain();
                        }
                    }
                }

                if (response.manutenzione || !nuoviLocali.length) {
                    this.maintenance = true;
                    this.maintenanceText = null;
                } else if (!nuoviLocali.find(nuovoLocale => nuovoLocale.licenza.f_attivo)) {
                    this.maintenance = true;
                    this.maintenanceText = nuoviLocali[0].licenza.testo;
                } else {
                    this.maintenance = false;
                    this.maintenanceText = null;
                }
            }
        },
        retrieveCouponCounter: async function () {
            let response = null;

            try {
                response = await getCoupons(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    api_key: this.user.api_key,
                    f_nascosto: 0,
                    counter_form: true
                });
            } catch ({messages}) {
                alert(messages.join('\n'));
            }

            if (response) {
                this.counter_discount_codes = response.codici_sconto;
            }
        },
        retrieveMessages: async function () {
            let response = null;

            try {
                response = await status(this.language, {
                    id_ristorante: this.id_ristorante,
                    api_key: this.user.api_key,
                    with_chat: !this.can_receive_notifications
                });
            } catch ({messages}) {
                alert(messages.join('\n'));
            }

            if (response) {
                if (!this.can_receive_notifications) {
                    if (('Notification' in window)) {
                        const deliverNotifications = (messages) => {
                            messages.forEach((message) => {
                                const found_message = this.unread_messages.find((current_message) => {
                                    return message.id === current_message.id
                                });

                                if (!found_message) {
                                    const notification = new Notification(
                                        message.chat.chatable_type + ' n.' + message.chat.chatable_id,
                                        {body: message.messaggio}
                                    );
                                }
                            });
                        };

                        if (Notification.permission === 'granted') {
                            deliverNotifications(response.messages_not_read);
                        } else if (Notification.permission !== 'denied') {
                            Notification.requestPermission().then((permission) => {
                                if (permission === 'granted') {
                                    deliverNotifications(response.messages_not_read);
                                }
                            });
                        }
                    }
                }

                this.setUnreadMessages(response.messages_not_read);
                //response.f_notifiche_a ???
            }
        },
        checkLanguage: function () {
            let foundLanguage = null;
            if (!this.initialized) {
                foundLanguage = this.lingue_attive.find(language => language.codice === this.$root.$i18n.fallbackLocale);
            }

            if (!foundLanguage) {
                foundLanguage = this.lingue_attive.find(language => language.codice === this.language);
                if (!foundLanguage) {
                    if (this.lingue_attive.length) {
                        foundLanguage = this.lingue_attive[0];
                    }
                }
            }

            if (!this.initialized || foundLanguage.codice !== this.language) {
                return foundLanguage.codice;
            }

            return false;
        },
        handleLogout: function () {
            this.removeUserData();
            this.$router.replace({name: 'home'}).catch(err => {
                //vuol dire che sono già nella home
            });
        },
        //START Notifications
        setupFirebase: async function () {
            try {
                await firebase.setup(this.targaRistorante);
                const token = await firebase.setupMessaging(
                    this.fwpcRistorante,
                    this.userAuthenticated
                );
                if (token) {
                    firebase.addOnMessageCallback(this.onFirebaseMessage);

                    await sendFirebaseToken(this.language, {
                        id_ristorante: this.id_ristorante,
                        email: this.user.email,
                        api_key: this.user.api_key,
                        token,
                        type: "FCM",
                        unique_id: this.user.iid
                    });

                    this.can_receive_notifications = true;
                }
            } catch (e) {
                this.can_receive_notifications = false;
            }
        },
        onFirebaseMessage: function (payload) {
            // ...
            switch (payload.data.type) {
                case 'CHAT_MESSAGE':
                    this.addUnreadMessage(JSON.parse(payload.data.raw_db));
                    break;
                case 'MARK_MESSAGES':
                    this.setMessageReadDatetime(JSON.parse(payload.data.messages_ids));
                    break;
                case 'CODICE_SCONTO':
                    const rooms_id = JSON.parse(payload.data.rooms_id);
                    if (rooms_id.includes(this.locale.id.toString())) {
                        this.counter_discount_codes += 1;
                    }
                    break;
                default:
                    console.warn('type not recognized:', payload.data.type);
                    break;
            }

            if (payload.notification) {
                const notificationTitle = payload.notification.title;
                const notificationOptions = {
                    body: payload.notification.body.substr(0, 50),
                    icon: '/img/ico/favicon.ico',
                };
                // If it's okay let's create a notification
                const notification = new Notification(notificationTitle, notificationOptions);
                notification.onclick = function (e) {
                    this.$router.push({name: 'messaging'}).catch(() => {
                        //we are already in messaging section
                    });
                    notification.close();
                };
            }
        },
        goToMain: function () {
            let service = null;
            let point = null;

            if (this.restaurant.f_distretto || (this.restaurant.f_modalita_fiera && this.restaurant.punti_di_servizio && this.restaurant.punti_di_servizio.length)) {
                if (this.restaurantServices().length > 1) {
                    this.$router.replace({name: 'rooms.type'});
                } else if (this.restaurantServices().length) {
                    service = this.restaurantServices()[0];

                    if (service === 'DIL') {
                        if (this.restaurant.punti_di_servizio.length > 1) {
                            this.$router.replace({name: 'rooms.zone', query: {service}});
                        } else if (this.restaurant.punti_di_servizio.length) {
                            point = this.restaurant.punti_di_servizio.punti_di_servizio[0];

                            const roomsIds = point.conf_ordini_prenotazioni_pds.map(
                                (conf) => conf.id_locale,
                            );

                            const rooms = this.restaurant.locali.filter((room) => {
                                return roomsIds.includes(room.id);
                            });

                            if (this.restaurant.franchising && rooms.length > 1) {
                                this.$router.replace({name: 'rooms', query: {service, pointId: point.id}});
                            } else {
                                this.setLocale(locale);
                                this.setDefaultParams({
                                    id_punto_di_servizio_default: point.id,
                                    type_default: service
                                });
                                this.$router.replace({name: 'home'});
                            }
                        }
                    }
                }
            } else if (this.restaurant.franchising && this.restaurant.locali.length > 1) {
                this.$router.replace({name: 'rooms'});
            } else {
                this.setLocale(locale);
                this.$router.replace({name: 'home'});
            }
            //se arrivi qui caro mio...sei nella merda più totale
        },
        //END Notifications
        ...mapActions('global', [
            'showSplashscreen',
            'showModalErrors'
        ]),
        ...mapActions('restaurant', [
            'initialize',
            'setLocale',
            'setLocali'
        ]),
        ...mapActions('localization', [
            'setLanguage'
        ]),
        ...mapActions('auth', [
            'removeUserData'
        ]),
        ...mapActions('chat', [
            'setUnreadMessages',
            'addUnreadMessage',
            'setMessageReadDatetime'
        ]),
        ...mapActions('order', {
            startBlinker: 'startBlinker',
            startOrderAlertTime: 'startAlertTime',
            setDefaultParams: 'setDefaultParams'
        })
    }
}
</script>
